import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dec29be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "SHOWS IN YOUR ACCOUNT")
], -1))
const _hoisted_3 = { class: "info-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, " Move your Artworks around by dragging and dropping them into your preferred order! ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoader = _resolveComponent("SpinnerLoader")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_InsideSearch = _resolveComponent("InsideSearch")!
  const _component_ShowCard = _resolveComponent("ShowCard")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_Container = _resolveComponent("Container")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_SpinnerLoader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_v_divider),
            _createVNode(_component_InsideSearch, {
              button: "Add Show",
              onSearch: _ctx.filterShows
            }, null, 8, ["onSearch"]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", {
                style: {"cursor":"pointer"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveOrder && _ctx.saveOrder(...args)))
              }, [
                _createTextVNode(" Save Order "),
                (_ctx.isSaving)
                  ? (_openBlock(), _createBlock(_component_SpinnerLoader, {
                      key: 0,
                      color: 'white',
                      class: "save-loader"
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_v_divider),
            _createVNode(_component_Container, {
              orientation: "vertical",
              onDrop: _ctx.onDrop
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredGalleryShows, (show) => {
                  return (_openBlock(), _createBlock(_component_Draggable, {
                    key: show.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ShowCard, {
                        exhibition: show,
                        draggable: "",
                        onDelete: ($event: any) => (_ctx.showAlert(show.id)),
                        onMoveUp: ($event: any) => (_ctx.moveUp(show.id)),
                        onMoveDown: ($event: any) => (_ctx.moveDown(show.id))
                      }, null, 8, ["exhibition", "onDelete", "onMoveUp", "onMoveDown"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["onDrop"]),
            (_ctx.allGalleryShows.length > _ctx.limit)
              ? (_openBlock(), _createBlock(_component_PaginationComponent, {
                  key: 0,
                  pageSize: _ctx.pageSize,
                  data: _ctx.length,
                  "current-page": _ctx.currentPage,
                  onPageChanged: _ctx.updatePagination
                }, null, 8, ["pageSize", "data", "current-page", "onPageChanged"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }))
}